"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formHelperText = void 0;

var _stylitas = require("@creditas/stylitas");

const formHelperText = ({
  theme
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.form(theme)};
  font-weight: 300;
  padding: 0;
  margin: 0;
`;

exports.formHelperText = formHelperText;